/* ============
 * The initial state of the careplan module.
 * ============
 */

export default {
  categories: {}
};
